import { useEffect } from 'react';
import {
  getAbsoluteAssetUrl,
  getJsonLd,
  getKeywords,
  getRouteSeo,
  getRouteUrl,
  seoConfig,
} from '../../constants/seo';

function upsertMeta(attributeName, attributeValue, content) {
  if (!content) {
    return;
  }

  let meta = document.head.querySelector(`meta[${attributeName}="${attributeValue}"]`);

  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute(attributeName, attributeValue);
    document.head.appendChild(meta);
  }

  meta.setAttribute('content', content);
}

function upsertCanonical(href) {
  let link = document.head.querySelector('link[rel="canonical"]');

  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }

  link.setAttribute('href', href);
}

function upsertJsonLd(id, data) {
  let script = document.getElementById(id);

  if (!script) {
    script = document.createElement('script');
    script.id = id;
    script.type = 'application/ld+json';
    document.head.appendChild(script);
  }

  script.textContent = JSON.stringify(data);
}

function Seo({ path }) {
  useEffect(() => {
    const seo = getRouteSeo(path);
    const canonicalUrl = getRouteUrl(path);
    const imageUrl = getAbsoluteAssetUrl(seo.imagePath || seoConfig.defaultImagePath);
    const robots = seo.robots || 'index,follow,max-image-preview:large';

    document.documentElement.lang = 'ko';
    document.title = seo.title;

    upsertCanonical(canonicalUrl);
    upsertMeta('name', 'description', seo.description);
    upsertMeta('name', 'keywords', getKeywords(seo));
    upsertMeta('name', 'robots', robots);
    upsertMeta('name', 'application-name', seoConfig.siteName);
    upsertMeta('name', 'apple-mobile-web-app-title', seoConfig.siteName);
    upsertMeta('name', 'theme-color', '#0095dd');

    upsertMeta('property', 'og:locale', seoConfig.locale);
    upsertMeta('property', 'og:site_name', seoConfig.siteName);
    upsertMeta('property', 'og:type', 'website');
    upsertMeta('property', 'og:title', seo.title);
    upsertMeta('property', 'og:description', seo.description);
    upsertMeta('property', 'og:url', canonicalUrl);
    upsertMeta('property', 'og:image', imageUrl);
    upsertMeta('property', 'og:image:alt', `${seoConfig.siteName} 대표 이미지`);

    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', seo.title);
    upsertMeta('name', 'twitter:description', seo.description);
    upsertMeta('name', 'twitter:image', imageUrl);

    upsertJsonLd('marlta-route-jsonld', getJsonLd(path, seo));
  }, [path]);

  return null;
}

export default Seo;
